// extracted by mini-css-extract-plugin
export default {"authOtpTabsContainer":"add-crypto-address-popup_authOtpTabsContainer__D0fPm"};